import React from 'react';
import { motion } from 'framer-motion';

interface Props {
  sectionVariants: any;
  itemVariants: any;
  title?: string;
  description?: string;
}

const AboutSection: React.FC<Props> = ({
  sectionVariants,
  itemVariants,
  title = "An independent venture studio",
  description = "TND Labs is the platform David and Tamara McKinney use to create, build, and operate businesses across industries. We don't chase one category or one type of product — we chase ideas worth building."
}) => {
  return (
    <motion.section
      id="about"
      className="py-28 md:py-36 px-6 md:px-12 bg-neutral-lightest border-t border-ink-line"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.15 }}
      variants={sectionVariants}
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-12 md:gap-20">
        <div className="md:col-span-4">
          <motion.p
            className="text-xs uppercase tracking-eyebrow text-ink-muted mb-8"
            variants={itemVariants}
          >
            About
          </motion.p>
          <motion.h2
            className="font-display text-4xl md:text-5xl leading-tight tracking-tight"
            variants={itemVariants}
          >
            {title}
          </motion.h2>
        </div>

        <div className="md:col-span-8">
          <motion.p
            className="text-2xl md:text-3xl font-display leading-snug mb-10"
            variants={itemVariants}
          >
            An engineering approach to building businesses.
          </motion.p>
          <div className="space-y-6 max-w-2xl">
            <motion.p className="text-lg text-ink-soft leading-relaxed" variants={itemVariants}>
              {description}
            </motion.p>
            <motion.p className="text-lg text-ink-soft leading-relaxed" variants={itemVariants}>
              Every venture starts the same way: understand the system, find the real constraint,
              develop a thesis, and test it against reality before scaling it — the same discipline
              whether we're building software or an operating business.
            </motion.p>
            <motion.p className="text-lg text-ink leading-relaxed" variants={itemVariants}>
              Question assumptions, build deliberately, test in the real world, keep improving.
            </motion.p>
          </div>

          <motion.div
            className="grid grid-cols-3 gap-8 mt-16 pt-10 border-t border-ink-line max-w-2xl"
            variants={itemVariants}
          >
            <div>
              <p className="font-display text-4xl md:text-5xl mb-2">2</p>
              <p className="text-[11px] uppercase tracking-eyebrow text-ink-muted">Co-Founders</p>
            </div>
            <div>
              <p className="font-display text-4xl md:text-5xl mb-2">3</p>
              <p className="text-[11px] uppercase tracking-eyebrow text-ink-muted">Active Ventures</p>
            </div>
            <div>
              <p className="font-display text-4xl md:text-5xl mb-2">3</p>
              <p className="text-[11px] uppercase tracking-eyebrow text-ink-muted">Industries</p>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default AboutSection;
